import { getDictPhrase } from "../../../common";
import { getMarketResultProps, getEventNameProps, getOccurrenceProps, getRuleDeductionProps } from "../../selection";
import { BetTypes } from "../../../../types";
export const getEventDetailsOutrightProps = (betType, selection, state) => {
    return {
        eventName: getEventNameProps(selection),
        occurrence: getOccurrenceProps(selection.startEventDate, state, getDictPhrase(state.dict, "Starts")),
        marketResult: betType !== BetTypes.YourBet ? getMarketResultProps(selection, state) : undefined,
        ruleDeduction: selection.rule4Deduction ? getRuleDeductionProps(selection) : undefined
    };
};
//# sourceMappingURL=getEventDetailsOutrightProps.js.map